// /var/www/afra/web-design.rampagesoft.com/my-app/src/utility/utils.js
export const stripHtml = html => {
  if (!html) return '';
  const div = document.createElement('div');
  div.innerHTML = html;
  return div.textContent || div.innerText || '';
};

export const truncateText = (text, max) => {
  if (!text) return '';
  return text.length <= max ? text : text.substring(0, max) + '...';
};

export const createUrlFriendlyString = text => {
  if (!text) return '';
  return encodeURIComponent(text)
    .replace(/%20/g, '-')
    .replace(/%[0-9A-F]{2}/g, match => (match === '%2F' ? '/' : match));
};

export const formatDate = dateString => {
  if (!dateString) return '';
  try {
    const d = new Date(dateString);
    if (isNaN(d.getTime())) return 'Invalid Date';
    return d.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    });
  } catch (e) {
    return 'Invalid Date';
  }
};

export const getImageUrl = (imgValue, defaultImage) => {
  if (!imgValue) return defaultImage;
  const cleanImgValue = imgValue.replace(/^\./, '').trim();
  if (cleanImgValue.startsWith('http://') || cleanImgValue.startsWith('https://')) {
    return cleanImgValue;
  }
  const pathSegment = cleanImgValue.startsWith('/') ? cleanImgValue.substring(1) : cleanImgValue;
  return `https://maracar.rampagesoft.com/model/upload/img/IMG_Home/${pathSegment}`;
};